//@ts-nocheck

'use client'

import React, { useEffect, useRef } from 'react'
import Image from 'next/image'
import FooterLogo from './FooterLogo.component'

import SectionThemeProvider from '../../../contexts/SectionTheme.context'

import { Col, Container, Row, SpacerBase, Visible } from '../../atoms/GridSystem'
import { Paragraph } from '../../atoms/Typography/Typography.component'
import Icon from '../../atoms/Icon/Icon.component'
import Button from '../../atoms/Button/Button.component'

import * as S from './Footer.styles'
import Accordion from '../../molecules/Accordion/Accordion.component'


const Footer = ({
  clientServiceText,
  contactList,
  menuList,
  copyText,
  legalMenu,
  socials,
  legalText,
  privacyText,
}) => {

  return (
    <SectionThemeProvider colorScheme="footer">
      <S.Footer colorScheme="footer">
        <Container>
          <S.FooterTop>
            <S.FooterInfo as={Col} xs={12} md={6} lg={3}>
              <FooterLogo />
              <SpacerBase xs={4} />
              { clientServiceText ? (
                <>
                  <Paragraph typo="paragraphMD">{clientServiceText}</Paragraph>
                  <SpacerBase xs={4} />
                </>
              ) : null}
              {contactList && contactList.length > 0 ? (
                <S.FooterContactList>
                  {contactList.map((listItem, i) => (
                    <S.FooterContactListItem
                      key={`footer-contact-list-item-${i}`}
                    >
                      <Icon name={listItem.icon} />
                      <Paragraph typo="paragraphMD">
                        {listItem.text}
                      </Paragraph>
                    </S.FooterContactListItem>
                  ))}
                </S.FooterContactList>
              ) : null}
            </S.FooterInfo>
            <Col xs={12} md={6} lg={9} $noGutter={true}>
              <Visible breakpoints={['xxl', 'xxxl']}>
                {menuList && menuList.length > 0 ? (
                  <Row>
                    {menuList.map(({ menuLabel, menuLinks }, i) => (
                      <Col
                        xs={12}
                        md={6}
                        xl={4}
                        key={`footer-menu-list-item-${i}`}
                      >
                        <S.FooterMenuListLabel
                          as={Paragraph}
                          typo="paragraphMD"
                          content={menuLabel}
                        />
                        <SpacerBase xs={2} />
                        {menuLinks && menuLinks.length > 0
                          ? menuLinks.map((menuLink, i) => (
                              <S.FooterMenuListItem
                                key={`footer-menu-list-item-${i}`}
                              >
                                <Button {...menuLink} variant="quaternary" iconEnd={'arrow-right'} inheritedColorScheme={'green'} />
                              </S.FooterMenuListItem>
                            ))
                          : null}
                        <SpacerBase xs={5} />
                      </Col>
                    ))}
                  </Row>
                ) : null}
              </Visible>
              <Visible breakpoints={['xs', 'sm', 'md', 'lg', 'xl']}>
                {menuList && menuList.length > 0 ? (
                  <Row>
                    {menuList.map(({ menuLabel, menuLinks }, i) => (
                      <Col
                        xs={12}
                        md={6}
                        xl={6}
                        key={`footer-menu-list-item-${i}`}
                      >
                        <Accordion
                          variant={'base'}
                          items={[
                            {
                              title: menuLabel,
                              links: menuLinks,
                            },
                          ]}
                          inheritedColorScheme={'green'}
                        />
                      </Col>
                    ))}
                  </Row>
                ) : null}
              </Visible>
            </Col>
          </S.FooterTop>
          <S.FooterBottom>
            {copyText ? (
              <S.FooterBottomCopy
                as={Paragraph}
                typo="paragraphMD"
                content={copyText}
                weight="medium"
              />
            ) : null}
            {legalMenu && legalMenu.length > 0 ? (
              <S.FooterBottomMenu>
                {legalMenu.map((menuLink, i) => (
                  <Button
                    {...menuLink}
                    variant="quaternary"
                    inheritedColorScheme={'green'}
                    key={`footer-bottom-menu-list-item-${i}`}
                  />
                ))}
              </S.FooterBottomMenu>
            ) : null}
            {socials && socials.length > 0 ? (
              <S.FooterSocials>
                {socials.map(({ type, link }, i) => (
                  <Button
                    href={link}
                    target="_blank"
                    ariaLabel={type}
                    variant="tertiary"
                    iconEnd={type}
                    useIconColor
                    key={`footer-social-item-${i}`}
                  />
                ))}
              </S.FooterSocials>
            ) : null}
          </S.FooterBottom>
          <SpacerBase xs={4} />
          {legalText ? (
            <>
              <Paragraph typo="paragraphSM" content={legalText} />
              <SpacerBase xs={4} />
            </>
          ) : null}
          {privacyText ? (
            <Paragraph typo="paragraphXS" content={privacyText} />
          ) : null}
        </Container>
      </S.Footer>
    </SectionThemeProvider>
  )
}

export default Footer
